'use client'

import { useLocale } from 'next-intl';
import { usePathname } from 'next-intl/client';
import Link  from 'next-intl/link';

function slugToCleanString(slug:string) {
    // Split the slug into an array of words using hyphens as the delimiter
    const words = slug.split('-');
  
    // Capitalize the first letter of each word and join them with spaces
    const cleanString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  
    return cleanString;
}

interface Breadcrumb {
    name: string;
    url: string;
}

export default function CarecoinsBreadcrumbs() {
    const locale = useLocale();
    const asPath = usePathname();

    // Parse the pathname to extract breadcrumb items
    const pathSegments = asPath.split('/').filter((segment) => segment !== '');

    const breadcrumbs: Breadcrumb[] = pathSegments.map((segment, index) => {
        const url = `/${pathSegments.slice(0, index + 1).join('/')}`;
        return { name: segment, url };
    });



    return (
        <>

            <div className="container py-5">
                <nav aria-label="Breadcrumb" className="breadcrumbs">
                    <ol className="flex flex-nowrap flex-row">
                        <li className="breadcrumb-seperator">
                            <Link
                                href={"/"}
                                itemProp="item"
                                itemScope
                                itemType="http://schema.org/ListItem"
                            >
                                <span itemProp="name">Home</span>
                            </Link>
                        </li>
                        {breadcrumbs.map((item, index) => (
                            <li
                                key={index}
                                itemScope
                                itemType="http://schema.org/BreadcrumbList"
                                itemProp="itemListElement"
                                className="breadcrumb-seperator"
                            >
                                <Link
                                    href={item.url}
                                    itemProp="item"
                                    itemScope
                                    itemType="http://schema.org/ListItem"
                                >
                                    <span itemProp="name">{slugToCleanString(item.name)}</span>
                                </Link>
                                <meta itemProp="position" content={(index + 1).toString()} />
                            </li>
                        ))}
                    </ol>
                </nav>
                {/* <Breadcrumbs 
                    rootLabel="Home" 
                    listClassName={"flex flex-nowrap flex-row"}
                    inactiveItemClassName={
                        "breadcrumb-seperator capitalize"
                    }
                    activeItemClassName={"capitalize font-bold"}
                /> */}
            </div>
        </>
    )
}